import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import { Link } from 'gatsby';
import { OutboundLink } from 'gatsby-plugin-gtag';
import { EuiSpacer } from '@elastic/eui';
import NavButtons from 'components/Indoor_Cameras/IN-8815_QFHD/NavButtons';
import CompareIndoor from 'components/Products/Compare/CompareIndoorFlyout';
import IndoorData from 'components/Products/Flyouts/Graphs/IndoorGraphsFlyout';
import SmartCards from 'components/Products/Flyouts/Cards/8401Cards';
import BreadCrumbs from 'components/Layout/BreadCrumbs';
import SEOHelmet from 'components/Layout/SEOHelmet';
export const _frontmatter = {
  "title": "IN-8815 4K QFHD",
  "path": "/Innenkameras/IN-8815_QFHD/",
  "dateChanged": "2017-12-12",
  "author": "Mike Polinowski",
  "excerpt": "INSTAR IN-8415 WQHD Innen IP Kamera",
  "image": "../P_SearchThumb_IN-8001HD.png",
  "social": "/images/Search/P_SearchThumb_IN-8815QFHD.webp",
  "toc": "/images/Search/TOC_Icons/Wiki_Tiles_P-IN-8415WQHD_white.webp",
  "chapter": "Indoor Cameras"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">





    <SEOHelmet title='IN-8815 4K QFHD' dateChanged='2017-12-12' author='Mike Polinowski' tag='INSTAR IP Camera' description='INSTAR IN-8415 WQHD Innen IP Kamera' image='/images/Search/P_SearchThumb_IN-8815QFHD.webp' twitter='/images/Search/P_SearchThumb_IN-8815QFHD.webp' location={props.location.pathname} mdxType="SEOHelmet" />
    <BreadCrumbs locationBC={props.location} locationDE={props.location.pathname} locationEN='/en/Indoor_Cameras/IN-8815_QFHD/' locationFR='/fr/Indoor_Cameras/IN-8815_QFHD/' crumbLabel="IN-8415" mdxType="BreadCrumbs" />
    <NavButtons mdxType="NavButtons" />
    <h1 {...{
      "id": "in-8815-4k-qfhd-handbuch",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h1" {...{
        "href": "#in-8815-4k-qfhd-handbuch",
        "aria-label": "in 8815 4k qfhd handbuch permalink",
        "className": "header-link-icon before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a>{`IN-8815 4K QFHD Handbuch`}</h1>
    <CompareIndoor mdxType="CompareIndoor" />
    <h2 {...{
      "id": "produkt-übersicht",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h2" {...{
        "href": "#produkt-%C3%BCbersicht",
        "aria-label": "produkt übersicht permalink",
        "className": "header-link-icon before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a>{`Produkt Übersicht`}</h2>
    <p>{`INSTAR IN-8815 4K QFHD Pan&Tilt Nachtsicht-Überwachungskamera (LAN/WLAN) Kleine aber feine Innenkamera mit 850nm Infrarot-LEDs, PIR-Sensor und SD-Karte. 3 Sekunden Voraufzeichnung vor dem Alarm. Smarthome-Kompatibilität dank Homekit, Alexa Skill, IFTTT und CGI & MQTT Interface. Das kompakte Design dieser Kamera wurde komplett neu entwickelt und macht sie ideal für diskrete Überwachungsaufgaben.`}</p>
    <p>{`Die IN-8815 4K QFHD Überwachungskamera ist bereit für die Implementierung in bestehende Sicherheitssysteme. Mit Hilfe des praktischen `}<strong parentName="p">{`Onvif Profile T`}</strong>{` Protokolls ist die Integration nur ein paar Knopfdrücke entfernt. Aber auch als eigenständiges Gerät bietet sie Ihnen eine Reihe von Alarmfunktionen wie `}<Link to="/Bewegungserkennung/Alarm_Benachrichtigung/" mdxType="Link">{`Email & Push Notification`}</Link>{`, Zwei-Wege-Kommunikation und eine Alarmsirene. Mit der WPS-Funktion können Sie die Kamera mit einem Tastendruck mit Ihrem WiFi-Netzwerk verbinden. Der Zugriff auf Ihre Kamera über das Internet ist noch einfacher. Die Punkt-2-Punkt-Verbindung kann durch Scannen eines QR-Codes mit unserer Smartphone-App hergestellt werden. Die kostenlose `}<strong parentName="p">{`InstarVision`}</strong>{` Mobile App ist verfügbar für `}<a parentName="p" {...{
        "href": "/de/Software/Android/InstarVision/"
      }}>{`Android`}</a>{`, `}<a parentName="p" {...{
        "href": "/de/Software/iOS/InstarVision/"
      }}>{`iOS`}</a>{`, `}<a parentName="p" {...{
        "href": "/de/Software/Windows/InstarVision/Metro/"
      }}>{`Windows Metro`}</a>{` und `}<a parentName="p" {...{
        "href": "/de/Software/Windows/InstarVision/Windows_Phone/"
      }}>{`Windows Phone`}</a>{`.`}</p>
    <IndoorData mdxType="IndoorData" />
    <EuiSpacer mdxType="EuiSpacer" />
    <p>{`Die Empfindlichkeit des integrierten Panasonic `}<strong parentName="p">{`Pyroelektrischen Sensors`}</strong>{` wurde dank eines einzigartigen Spaltdesigns der pyroelektrischen Elemente deutlich verbessert. Die getrennten Sensorbereiche verhindern ein thermisches Übersprechen zwischen den einzelnen Sensorelementen. Dies ermöglicht eine zuverlässige Erkennung, selbst wenn der Temperaturunterschied zwischen dem Hintergrund (z. B. Boden/Wand) und dem Zielobjekt (menschlicher Körper, Automotor usw.) gering ist (etwa 4 °C).`}</p>
    <h3 {...{
      "id": "hardware",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h3" {...{
        "href": "#hardware",
        "aria-label": "hardware permalink",
        "className": "header-link-icon before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a>{`Hardware`}</h3>
    <ul>
      <li parentName="ul">{`Integrierter PIR-Wärmemelder für erweiterte Bewegungserkennung
`}<strong parentName="li">{`STARVIS`}</strong>{` 2160p `}<Link to="/Innenkameras/IN-8815_QFHD/Technische_Spezifikationen/" mdxType="Link">{`SONY CMOS Sensor`}</Link></li>
      <li parentName="ul">{`Eingebautes Mikrofon inkl. Geräuscherkennung mit einstellbarem Maximalpegel, Software Audiorauschen- und Echounterdrückung`}</li>
      <li parentName="ul">{`Eingebauter PIR-Bewegungsmelder zur Vermeidung von Fehlalarmen`}</li>
      <li parentName="ul">{`Zusätzliche leistungsstarke 850-nm-IR-Nachtsicht-LEDs (manuell aktiviert oder durch den integrierten PIR-Sensor ausgelöst)`}</li>
      <li parentName="ul">{`Geeignet für Wand- und Deckenmontage`}</li>
      <li parentName="ul">{`MicroSD-Speicherkarten bis zu 256 GB möglich. (32GB bereits installiert)`}</li>
    </ul>
    <h3 {...{
      "id": "netzwerk",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h3" {...{
        "href": "#netzwerk",
        "aria-label": "netzwerk permalink",
        "className": "header-link-icon before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a>{`Netzwerk`}</h3>
    <ul>
      <li parentName="ul">{`RJ-45-Ethernet-Anschluss für eine einfache Integration in Ihr 100-Mbit-Heimnetzwerk`}</li>
      <li parentName="ul">{`Kompatibel mit `}<Link to="/Schnell_Installation/Herstellen_der_WLAN_Verbindung/" mdxType="Link">{`WiFi`}</Link>{` 5GHz / 2.4GHz, Wi-Fi 5 (802.11ac) für 866 Mbit/s Netzwerke mit WPA2/WPA3/Enterprise Sicherheit`}</li>
      <li parentName="ul">{`DHCP- und UPnP-Unterstützung für eine automatische Netzwerkintegration`}</li>
      <li parentName="ul">{`Integrierte persönliche, kostenlose `}<Link to="/Fernzugriff/Der_DDNS_Dienst/" mdxType="Link">{`DDNS ("Internet") Adresse`}</Link>{` für den Zugriff auf Ihre Kamera über das Internet`}</li>
    </ul>
    <h3 {...{
      "id": "software",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h3" {...{
        "href": "#software",
        "aria-label": "software permalink",
        "className": "header-link-icon before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a>{`Software`}</h3>
    <ul>
      <li parentName="ul">{`Kostenlose `}<Link to="/Software/Android/" mdxType="Link">{`Android`}</Link>{`, `}<Link to="/Software/iOS/" mdxType="Link">{`iPhone`}</Link>{` und `}<Link to="/Software/Windows/" mdxType="Link">{`Windows Phone`}</Link>{` App`}</li>
      <li parentName="ul">
        <Link to="/Web_User_Interface/2160p_Serie/" mdxType="Link">Web-Benutzeroberfläche</Link> ermöglicht eine einfache Konfiguration und Kamerasteuerung über Ihren Standard-Webbrowser (Chrome, Safari, Firefox, Internet Explorer)
      </li>
      <li parentName="ul">
        <Link to="/Web_User_Interface/2160p_Serie/System/User/" mdxType="Link">Benutzer- und Benutzerrechteverwaltung</Link> und gleichzeitige Anmeldung für multiple Benutzer
      </li>
      <li parentName="ul">
        <Link to="/Web_User_Interface/2160p_Serie/Alarm/Bereiche/" mdxType="Link">Softwarebasierte Bewegungs-</Link> und <Link to="/Web_User_Interface/2160p_Serie/Alarm/Aktionen/" mdxType="Link">Audio</Link>-Erkennung und <Link to="/Bewegungserkennung/Alarm_Benachrichtigung/" mdxType="Link"> {" "} E-Mail-Benachrichtigung </Link> mit angehängten Schnappschüssen
      </li>
      <li parentName="ul">{`Aufzeichnung von 15s Alarmvideos (+ 3s Voraufzeichnung) direkt auf eine `}<Link to="/Bewegungserkennung/SD_Karten_Zugriff/" mdxType="Link">{`interne SD-Karte`}</Link></li>
    </ul>
    <EuiSpacer mdxType="EuiSpacer" />
    <p>{`Sicherheitskameras müssen in der Lage sein, in einer Vielzahl von Umgebungen klare Bilder aufzuzeichnen. Die `}<strong parentName="p">{`STARVIS`}</strong>{` `}{`*`}{`-Bildsensoren von Sony erfüllen diese Anforderung, indem sie eine hohe Empfindlichkeit bieten, die für Aufnahmen bei schwachem Licht und bei Nacht geeignet ist. `}<strong parentName="p">{`STARVIS`}</strong>{` `}{`*`}{` ist eine Technologie mit hintergrundbeleuchteten Pixeln, die in CMOS-Bildsensoren für Sicherheitskameraanwendungen eingesetzt wird. Sie zeichnet sich durch hochempfindliche, hintergrundbeleuchtete Sensorpixel aus und ermöglicht eine hohe Bildqualität im Bereich des sichtbaren Lichts und des nahen Infrarotlichts. Der IMX335 `}<strong parentName="p">{`STARVIS`}</strong>{` `}{`*`}{`-Sensor ist ein diagonaler 2,8-Zoll-CMOS-Solid-State-Bildsensor mit aktiven Pixeln, einer quadratischen Pixelanordnung und 5,14 Mio. effektiven Pixeln.`}</p>
    <SmartCards mdxType="SmartCards" />
    <EuiSpacer mdxType="EuiSpacer" />
    <p>{`Der SONY `}<strong parentName="p">{`STARVIS`}</strong>{` `}{`*`}{` IMX335 CMOS-Sensor verfügt über einen Dynamikbereich von bis zu 72 dB, fortschrittliche HDR-Funktionen und digitales Overlap-HDR verbessern die Bildqualität und das Kontrastverhalten weiter und ermöglichen eine detailliertere Bildanalyse. In Kombination mit dem geringen Dunkelstrom verbessern diese Funktionen die Leistung der Kamera bei Anwendungen, die einen hohen Dynamikbereich erfordern, weiter.`}</p>
    <p>{`*`}{` `}<strong parentName="p">{`STARVIS`}</strong>{` ist ein Warenzeichen der Sony Corporation. Ein STARVIS-Sensor ist definiert durch eine Empfindlichkeit von `}<em parentName="p">{`2000 mV`}</em>{` oder mehr pro `}<em parentName="p">{`1 μm²`}</em>{` bei Beleuchtung mit einer `}<em parentName="p">{`706 cd/m²`}</em>{` Lichtquelle, `}<em parentName="p">{`F5.6`}</em>{` in `}<em parentName="p">{`1s`}</em>{` Akkumulationsäquivalent.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      